



// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Switch, Card, Skeleton, Form, Button } from 'antd';
// import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
// import EditProfileModal from './EditProfile'; // Adjust import path if necessary
// import { API_BASE_URL } from '../../utils/index';
// import '../ProfilePage/profilePage.scss';
// import { FiEdit } from 'react-icons/fi';
// import { CiLogout } from "react-icons/ci";
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Tilt } from 'react-tilt';
// import { FiEdit } from 'react-icons/fi';
// import { API_BASE_URL } from '../../utils/index';
// import EditProfileModal from './EditProfile'; // Adjust import path if necessary
// import "../ProfilePage/profilePage.scss"
// import { Avatar, Card, Skeleton, Switch } from 'antd';
// import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
// import { CiLogout } from "react-icons/ci";
// import { Form, Button } from 'react-bootstrap';
// import Updatepasswordprofilepage from './Updatepasswordprofilepage';
// const ProfilePage = () => {
//   const [user, setUser] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editedUser, setEditedUser] = useState({});
//   const [error, setError] = useState(null);
//   const [showMenu, setShowMenu] = useState(false);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   useEffect(() => {
//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       navigate('/login');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     axios
//       .get(`${API_BASE_URL}/admin/myprofile`, { headers })
//       .then((response) => {
//         setUser(response.data.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching user profile:', error);
//       });
//   }, [navigate]);

//   const handleEditSubmit = () => {
//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       navigate('/login');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     axios
//       .put(`${API_BASE_URL}/admin/updateprofile`, editedUser, { headers })
//       .then((response) => {
//         setUser(response.data.data);
//         setIsEditMode(false);
//       })
//       .catch((error) => {
//         console.error('Error updating user profile:', error);
//       });
//   };


//   const toggleMenu = () => {
//     setShowMenu(!showMenu);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('accessToken');
//     navigate('/login');
//   };

//   const handleEditClick = () => {
//     setIsEditMode(true);
//     setEditedUser({
//       firstName: user.firstName,
//       lastName: user.lastName,
//       email: user.email,
//       mobile: user.mobile,
//     });
//   };

//   const handleEditCancel = () => {
//     setIsEditMode(false);
//     setEditedUser({});
//   };

//   const onChangeLoading = (checked) => {
//     setLoading(!checked);
//   };

//   return (
//     <div className="profile-page">
//       <div className="row">
//         <div className="col-md-6">
//           <Switch checked={!loading} onChange={onChangeLoading} />

//           <Card
//             style={{ width: 300, marginTop: 16 }}
//             actions={[
//               <CiLogout key="logout" onClick={handleLogout} />,
//               <FiEdit key="edit" onClick={handleEditClick} />,
//               <EllipsisOutlined key="ellipsis" onClick={toggleMenu} />,
//             ]}
//           >
//             <Skeleton loading={loading} avatar active>
//               <img
//                 src="https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D"
//                 alt="Profile"
//                 className="profile-icon ms-5"
//               />
//               <h1 className="text-center">{user ? `${user.firstName} ${user.lastName}` : 'Loading...'}</h1>
//               <p className="profile-email text-center">{user ? user.email : 'Loading...'}</p>
//               <p className="profile-mobile text-center">{user ? user.mobile : 'Loading...'}</p>

//               {isEditMode && (
//                 <EditProfileModal
//                   editedUser={editedUser}
//                   setEditedUser={setEditedUser}
//                   handleEditSubmit={handleEditSubmit}
//                   handleEditCancel={handleEditCancel}
//                 />
//               )}
//             </Skeleton>
//           </Card>
//         </div>

//         <div className='col-md-6'>
//        <Updatepasswordprofilepage show={showLoginModal} handleClose={() => setShowLoginModal(false)}/>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;
// ------------------------------------------------------------------
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Tilt } from 'react-tilt';
// import { FiEdit } from 'react-icons/fi';
// import { API_BASE_URL } from '../../utils/index';
// import EditProfileModal from './EditProfile'; // Adjust import path if necessary
// import "../ProfilePage/profilePage.scss"
// import { Avatar, Card, Skeleton, Switch } from 'antd';
// import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
// import { CiLogout } from "react-icons/ci";
// import { Form, Button } from 'react-bootstrap';
// import Updatepasswordprofilepage from './Updatepasswordprofilepage';

// const ProfilePage = () => {
//   const [user, setUser] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editedUser, setEditedUser] = useState({});
//   const [error, setError] = useState(null);
//   const [showMenu, setShowMenu] = useState(false);
//   const [showLoginModal, setShowLoginModal] = useState(false); // State to control modal visibility
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   useEffect(() => {
//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       navigate('/login');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     axios
//       .get(`${API_BASE_URL}/admin/myprofile`, { headers })
//       .then((response) => {
//         setUser(response.data.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching user profile:', error);
//       });
//   }, [navigate]);

//   const handleEditSubmit = () => {
//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       navigate('/login');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     axios
//       .put(`${API_BASE_URL}/admin/updateprofile`, editedUser, { headers })
//       .then((response) => {
//         setUser(response.data.data);
//         setIsEditMode(false);
//       })
//       .catch((error) => {
//         console.error('Error updating user profile:', error);
//       });
//   };

//   const toggleMenu = () => {
//     setShowMenu(!showMenu);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('accessToken');
//     navigate('/login');
//   };

//   const handleEditClick = () => {
//     setIsEditMode(true);
//     setEditedUser({
//       firstName: user.firstName,
//       lastName: user.lastName,
//       email: user.email,
//       mobile: user.mobile,
//     });
//   };

//   const handleEditCancel = () => {
//     setIsEditMode(false);
//     setEditedUser({});
//   };

//   const onChangeLoading = (checked) => {
//     setLoading(!checked);
//   };

//   // Function to handle opening the password update modal
//   const handleShowPasswordModal = () => {
//     setShowLoginModal(true);
//   };
//   const toggleForm = () => setShowForm(!showForm);
//   return (
//     <div className="profile-page">
//       <div className="row">
//         <div className="col-md-6">
//           <Switch checked={!loading} onChange={onChangeLoading} />

//           <Card
//             style={{ width: 300, marginTop: 16 }}
//             actions={[
//               <CiLogout key="logout" onClick={handleLogout} />,
//               <FiEdit key="edit" onClick={handleEditClick} />,
//               <FiEdit key="edit" show={showLoginModal} handleClose={() => setShowLoginModal(false)} />, // Clicking EllipsisOutlined opens password update modal
//             ]}
//           >
//             <Skeleton loading={loading} avatar active>
//               <img
//                 src="https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D"
//                 alt="Profile"
//                 className="profile-icon ms-5"
//               />
//               <h1 className="text-center">{user ? `${user.firstName} ${user.lastName}` : 'Loading...'}</h1>
//               <p className="profile-email text-center">{user ? user.email : 'Loading...'}</p>
//               <p className="profile-mobile text-center">{user ? user.mobile : 'Loading...'}</p>

//               {isEditMode && (
//                 <EditProfileModal
//                   editedUser={editedUser}
//                   setEditedUser={setEditedUser}
//                   handleEditSubmit={handleEditSubmit}
//                   handleEditCancel={handleEditCancel}
//                 />
//               )}
//             </Skeleton>
//           </Card>
//         </div>

//         <div className='col-md-6' >
//           {/* Display the password update component */}
//           <Updatepasswordprofilepage  />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, Skeleton, Switch } from 'antd';
import { FiEdit } from 'react-icons/fi';
import { API_BASE_URL } from '../../utils/index';
import EditProfileModal from './EditProfile'; // Adjust import path if necessary
import { CiLogout } from 'react-icons/ci';
import Updatepasswordprofilepage  from './Updatepasswordprofilepage'; // Adjust import path if necessary
import { SettingOutlined } from '@ant-design/icons';
import "./profilePage.scss"
const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedUser, setEditedUser] = useState({});
  const [error, setError] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [showPasswordForm, setShowPasswordForm] = useState(false); // State to control password form visibility
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  useEffect(() => {
    const adminId = localStorage.getItem('accessToken');

    if (!adminId) {
      navigate('/login');
      return;
    }

    const headers = {
      Authorization: `Bearer ${adminId}`,
      'Content-Type': 'application/json',
    };

    axios
      .get(`${API_BASE_URL}/admin/myprofile`, { headers })
      .then((response) => {
        setUser(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching user profile:', error);
      });
  }, [navigate]);

  const handleEditSubmit = () => {
    const adminId = localStorage.getItem('accessToken');

    if (!adminId) {
      navigate('/login');
      return;
    }

    const headers = {
      Authorization: `Bearer ${adminId}`,
      'Content-Type': 'application/json',
    };

    axios
      .put(`${API_BASE_URL}/admin/updateprofile`, editedUser, { headers })
      .then((response) => {
        setUser(response.data.data);
        setIsEditMode(false);
      })
      .catch((error) => {
        console.error('Error updating user profile:', error);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    navigate('/login');
  };

  const handleEditClick = () => {
    setIsEditMode(true);
    setEditedUser({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      mobile: user.mobile,
    });
  };

  const handleEditCancel = () => {
    setIsEditMode(false);
    setEditedUser({});
  };

  // const onChangeLoading = (checked) => {
  //   setLoading(!checked);
  // };

  // Function to handle opening the password update form
  const handleShowPasswordModal = () => {
    setShowPasswordForm(true);
  };

  return (
    <div className="profile-page">
      
        
          {/* <Switch checked={!loading} onChange={onChangeLoading} /> */}

          <Card   className='profile '
            style={{ width: 300, marginTop: 16 }}
            actions={[
              <CiLogout key="logout" className='fs-4 fw-bolder' onClick={handleLogout} />,
              <FiEdit key="edit"  className='fs-4 fw-bolder' onClick={handleEditClick} />,
              <Updatepasswordprofilepage  show={showLoginModal} handleClose={() => setShowLoginModal(false)} />
              // <SettingOutlined key="password" onClick={handleShowPasswordModal} />, // Clicking SettingOutlined opens password update form
              // <SettingOutlined key="password" onClick={handleShowPasswordModal} />, // Clicking SettingOutlined opens password update form
                //  <>{!loading && <Updatepasswordprofilepage />}
                //  {loading && <SettingOutlined /> }
                //  </>
            ]}
          >
            
              <img
                src="https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D"
                alt="Profile"
                className="profile-icon ms-5"
              />
              <h1 className="text-center text-black">{user ? `${user.firstName} ${user.lastName}` : 'Loading...'}</h1>
              <p className="profile-email text-center text-black">{user ? user.email : 'Loading...'}</p>
              <p className="profile-mobile text-center text-black">{user ? user.mobile : 'Loading...'}</p>

              {isEditMode && (
                <EditProfileModal
                  editedUser={editedUser}
                  setEditedUser={setEditedUser}
                  handleEditSubmit={handleEditSubmit}
                  handleEditCancel={handleEditCancel}
                />
              )}

            
          
          </Card>
        </div>
     
  );
};

export default ProfilePage;
